import { useTranslation } from "react-i18next";

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full bg-background-100 py-16 md:py-24 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          {/* Left: Text */}
          <div className="flex-1">
            <span className="inline-block text-xs text-primary-600 bg-primary-100 px-3 py-1 rounded-full mb-6">
              Sobre CSSBuy Sheet
            </span>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 leading-snug mb-6">
              A maior coleção de
              <br />
              <span className="text-primary-600">links CSSBuy</span> em português
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-8 max-w-xl">
              Somos a fonte mais completa de links CSSBuy para a comunidade brasileira. Nossa spreadsheet reúne mais de 5.000 links organizados por categoria, todos verificados e atualizados diariamente. Compre tênis, roupas, acessórios e muito mais com segurança através dos melhores agentes.
            </p>

            {/* Two buttons: cssbuy sheet + buy it now */}
            <div className="flex flex-col sm:flex-row items-start gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                cssbuy sheet
                <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-transparent text-primary-600 border border-primary-300 rounded-full font-medium text-sm hover:bg-primary-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                buy it now
                <i className="ri-shopping-bag-3-line w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>

          {/* Right: Stats */}
          <div className="flex-1 grid grid-cols-2 gap-4">
            {[
              { icon: "ri-link", value: "5.000+", label: t("about.stats.links") },
              { icon: "ri-grid-line", value: "14", label: t("about.stats.categories") },
              { icon: "ri-refresh-line", value: "Diário", label: t("about.stats.updated") },
              { icon: "ri-shield-check-line", value: "100%", label: t("about.stats.verified") },
            ].map((stat) => (
              <div key={stat.label} className="bg-background-50 rounded-2xl p-6 flex flex-col items-center text-center">
                <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mb-4">
                  <i className={`${stat.icon} text-primary-600 text-xl w-5 h-5 flex items-center justify-center`}></i>
                </div>
                <span className="font-heading text-2xl md:text-3xl text-foreground-950 mb-1">{stat.value}</span>
                <span className="text-xs text-foreground-500">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}